import * as types from '../constants/actionTypes';
import initialState from './initialState';

export default function privateAlbumReducer(state = initialState.privateAlbums, action) {
  switch (action.type) {
    case types.UPDATE_GALLERY_ACCESS:
      // return state.asMutable({ deep: true }).map(a => {
      return state.map(a => {
        if (a.galleryId === action.galleryId) {
          return { ...a, isGranted: action.isGranted };
        }
        return a;
      });
    case types.GET_ALBUM_SUCCESS:
      return action.privateAlbums;
    case types.USER_LOGOUT_SUCCESS: {
      state = initialState.privateAlbums;
      return state;
    }
    default:
      return state;
  }
}
